import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1cfdfab8"
import script from "./list.ts?vue&type=script&lang=js&external"
export * from "./list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cfdfab8')) {
      api.createRecord('1cfdfab8', component.options)
    } else {
      api.reload('1cfdfab8', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1cfdfab8", function () {
      api.rerender('1cfdfab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/informacoesAdicionaisRepresentante/list.vue"
export default component.exports